var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating-container"},_vm._l((5),function(i){return _c('n-icon',_vm._b({key:i,staticClass:"rating-star feedback",class:[{
      'faded': _vm.filled(i),
      'not-rated': (_vm.rating === 0 || _vm.locked) && _vm.editable,
      'orange': !_vm.filled(i) && _vm.rated,
      'yellow': !_vm.filled(i) && _vm.color === 'yellow'
    }, _vm.size],attrs:{"color":_vm.filled(i) && _vm.editable ? 'grey' : '',"name":_vm.iconByIndex(i),"outline":_vm.filled(i) && _vm.editable},on:{"click":function($event){return _vm.rate(i)}}},'n-icon',_vm.$props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }